import type { FilterState } from './filter-panel';

export function hasActiveFilters(filters: FilterState): boolean {
  return (
    filters.types.size > 0 ||
    Boolean(filters.dateFrom) ||
    Boolean(filters.dateTo) ||
    filters.hasAttachments ||
    filters.onlyStarred ||
    filters.include.length > 0 ||
    filters.exclude.length > 0
  );
}

export function createInitialFilterState(): FilterState {
  return {
    types: new Set(),
    dateFrom: '',
    dateTo: '',
    hasAttachments: false,
    onlyStarred: false,
    include: [],
    exclude: [],
  };
}
